import { css } from '@emotion/core';
import { media, variables, insetBlock, clearfix } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var CUSTOM_TABLET_BREAKPOINT = '900px';
export var toolbar = /*#__PURE__*/css("padding:3px 0 15px;background:", colour.allhomesNavy600, ";font-size:", font.smallFontSize, ";line-height:", font.baseLineHeight, ";");
export var innerWrap = /*#__PURE__*/css(insetBlock, ";", clearfix, ";display:flex;align-items:center;justify-content:space-between;flex-direction:column;@media (min-width:", CUSTOM_TABLET_BREAKPOINT, "){flex-direction:row;}");
export var leftAligned = /*#__PURE__*/css("display:flex;", media('>=desktop'), "{flex-grow:2;}");
export var rightAligned = /*#__PURE__*/css("display:flex;justify-content:flex-end;flex-grow:2;flex-direction:column;align-items:center;margin-top:6px;@media (min-width:", CUSTOM_TABLET_BREAKPOINT, "){flex-direction:row;}", media('>=desktop'), "{flex-grow:1;}");
export var navItem = {
  name: "1njuths",
  styles: "display:inline-block;margin-top:12px;"
};
export var navLink = /*#__PURE__*/css("display:inline-block;color:", colour.white, ";text-decoration:none;position:relative;white-space:nowrap;z-index:1;&:hover,&:focus,&:active{text-decoration:underline;}");
export var socialList = /*#__PURE__*/css("display:flex;flex-wrap:nowrap;height:16px;margin-top:8px;@media (min-width:", CUSTOM_TABLET_BREAKPOINT, "){margin-top:0;}");
export var socialItem = {
  name: "a5qkfk",
  styles: "margin:0 10px;"
};
export var socialLink = /*#__PURE__*/css("display:inline-block;color:", colour.white, ";text-decoration:none;height:18px;&:hover,&:focus,&:active{text-decoration:underline;}");
export var socialIcon = {
  name: "19rsff",
  styles: "width:18px;height:18px;"
};
export var logoContainer = /*#__PURE__*/css("width:140px;height:24px;margin-top:12px;border-right:1px solid ", colour.neutral600, ";");
export var toolbarLogo = /*#__PURE__*/css("display:inline-block;color:", colour.white, ";text-decoration:none;transition:opacity 0.2s linear;opacity:0.7;position:relative;z-index:1;width:115px;height:24px;margin-top:-3px;margin-right:24px;&:hover,&:focus,&:active{text-decoration:underline;opacity:0.9;}");
export var toolbarNavList = /*#__PURE__*/css("display:flex;justify-content:center;flex-wrap:wrap;gap:24px;@media (min-width:", CUSTOM_TABLET_BREAKPOINT, "){justify-content:left;margin:0 12px;}");
export var quickLinksContainer = {
  name: "10zywh6",
  styles: "display:flex;flex-wrap:nowrap;flex-grow:2;justify-content:center;"
};
export var quickLinkSection = {
  name: "1bvc4cc",
  styles: "display:flex;justify-content:flex-end;"
};
export var quickLinkItem = {
  name: "19ug521",
  styles: "margin-top:6px;"
};